import React from "react";
import * as Icons from "lucide-react";
import useReveal from "../hooks/useReveal";
import { certifications } from "../mock";

const Certifications = () => {
  const [ref, inView] = useReveal();

  return (
    <section className="py-16 bg-white">
      <div ref={ref} className="pp-container">
        <div className={`text-center pp-reveal ${inView ? "pp-in" : ""}`}>
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#0D1B2A]">
            Security & <span className="pp-grad-text-orange">Compliance</span>
          </h2>
          <p className="text-[#475569] mt-2 text-sm">Built on bank-grade security practices you can trust.</p>
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-5 md:gap-7">
          {certifications.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.ShieldCheck;
            return (
              <div
                key={i}
                className={`flex items-center gap-3 px-6 py-4 rounded-2xl border border-slate-100 bg-[#f6f9fd] pp-lift pp-reveal ${inView ? "pp-in" : ""}`}
                style={{ animationDelay: `${i * 0.08}s` }}
              >
                <span className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: "linear-gradient(135deg,#0D1B2A,#0EA5E9)" }}>
                  <Icon size={20} className="text-[#10B981]" />
                </span>
                <span className="font-bold text-[#0D1B2A]">{c.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
